define.alias("ember-cli-clipboard/components/copy-button", "settings/components/copy-button");